export const obtenerDataBytesImagen = imagen => {
    return new Promise((resolve, eject) => {
        const nombre = imagen.name;
        const extension = imagen.name.split(".").pop();
        const tipo = imagen.type;

        const lector = new FileReader();
        const fileByteArray = [];
        lector.readAsArrayBuffer(imagen);
        lector.onloadend = (evt) => {
            if (evt.target.readyState === FileReader.DONE) {
                const arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
                for (const a of array) {
                    fileByteArray.push(a);
                }

                resolve(
                    {
                        archivo : fileByteArray,
                        titulo: nombre,
                        extension: '.' + extension,
                        contenttype: tipo
                    });
            }
        }
 
        lector.onerror = error => PromiseRejectionEvent(error);
    })
}